import { v4 as uuidv4 } from 'uuid';

export const loginData = (data) => ({
    tipo: "OPERACION_1-1",
    usuario: data.user,
    passwd: data.password,
});

export const responseLogin = ({data:{id, usuario, datos_usuario, token, roles}}) => ({
    id,
    user: {
        username: usuario,
        name: datos_usuario.nombre,
        surname: datos_usuario.apellidos,
    },
    token,
    projects: roles.map(transformRole),
});

export const responseToken = ({data:{ accessToken }}) => ({
    token: accessToken
});

export const responseUserMe = ({data:{ _id, email, displayName, photoUrl,...rest }}) => ({
    _id,
    email,
    displayName,
    ...rest
});

const transformRole = ({id_estudio, estudio, centro, id_centro, OC_DM, modulos, ...rest}) => {
    return ({
        id: id_estudio,
        name: estudio,
        hospital: {
            id: id_centro,
            name: centro
        },
        menu: [
            ...modulos.map(transformModules),
            headerMenu('Paciente', true, (OC_DM ? OC_DM.map((o) => transformOC_DM(o, rest.usuario)) : [])),
        ],
        ...rest,
    });
};

const headerMenu = (name, needPatient, submenu) => ({
    id: uuidv4(),
    name,
    type: 'header_menu',
    icon: undefined,
    url: undefined,
    parameter: undefined,
    modeView: 'default', // Enum ['default','tab','windows','pop up']
    needPatient: Boolean(needPatient),
    submenu,
});

const transformModules = ({id_modulo, nombre, ruta_logo, url, identificador, paciente_seleccionado}) => ({
    id: id_modulo,
    name: nombre,
    type: 'module',
    icon: ruta_logo,
    url: url+'/'+identificador,
    parameter: identificador,
    modeView: 'default', // Enum ['default','tab','windows','pop up']
    needPatient: Boolean(paciente_seleccionado),
    submenu: [],

});

const transformOC_DM = ({id_formulario, nombre_evento, nombre_formulario, ruta_logo, url, real_url, formularios}, user) => {
    const obj = {
        id: id_formulario ? id_formulario : uuidv4(),
        name: nombre_evento ? nombre_evento : nombre_formulario,
        type: 'OC_DM',
        icon: ruta_logo,
        url,
        parameter: id_formulario,
        modeView: 'default', // Enum ['default','tab','windows','pop up']
        submenu: formularios?.map(transformOC_DM) ?? [],
        needPatient: true,
    };

    if(url === '-1') {
        obj.modeView = 'popUp';
        obj.url = real_url.replace('XXXUSUARIOXXX', user)
    }

    return obj;
};
